import React from 'react'
import _ from 'lodash'
import styled from '@emotion/styled'
import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Comment, plainDateTime } from '@fusion-advantage/formlib'
import { FusionColor } from '../../../theme/FusionStyle'
import { Theme, useTheme } from '@emotion/react'
import { DateTime } from 'luxon'

type CommentCardProps = {
	backgroundColor?: FusionColor
} & {
	theme: Theme
}

export const CommentCard = styled.div(({theme, backgroundColor = FusionColor.White}: CommentCardProps) => ({
	backgroundColor: theme.colors[backgroundColor],
	borderRadius: theme.spacing(1),
	width: '100%'
}))

export const CommentCardHeader = styled.div(({theme}) => ({
	display: 'flex',
	padding: theme.spacing(1),
	justifyContent: 'flex-start',
	alignItems: 'center',
	flexDirection: 'row',
	gap: 10
}))

export const CommentCardHeaderAuthor = styled.div(({theme}) => ({
	color: theme.colors.blueMain,
	fontWeight: 600,
}))

export const CommentCardHeaderTimestamp = styled.div(({theme}) => ({
	color: theme.colors.miniHeader,
	fontStyle: 'italic',
	fontSize: '14px',
}))

export const CommentCardContent = styled.div(({theme}) => ({
	padding: theme.spacing(1),
	color: theme.colors.text,
}))

interface L1CommentCardProps {
	backgroundColor?: FusionColor,
	editable?: boolean,
	onEdit?: React.MouseEventHandler,
	comment: Comment
}

const L1CommentCard = ({comment, backgroundColor, editable = false, onEdit}: L1CommentCardProps) => {
	const theme = useTheme()

	return (
		<>
			<CommentCard backgroundColor={backgroundColor}>
				<CommentCardHeader>
					<CommentCardHeaderAuthor>{comment.authorName}</CommentCardHeaderAuthor>
					<CommentCardHeaderTimestamp>{plainDateTime(DateTime.fromMillis(comment.timestamp))}</CommentCardHeaderTimestamp>
					{
						editable && (
							<FontAwesomeIcon
								style={onEdit ? {cursor: 'pointer'} : {}}
								icon={faPenToSquare} 
								color={theme.colors.blueMain}
								onClick={onEdit}
							/>
						) 
					}
				</CommentCardHeader>
				<CommentCardContent>{comment.message}</CommentCardContent>
			</CommentCard>
		</>
	)
}

export default L1CommentCard